import { render, staticRenderFns } from "./RelationDeviceDialog.vue?vue&type=template&id=1b3820bc&scoped=true&"
import script from "./RelationDeviceDialog.vue?vue&type=script&lang=js&"
export * from "./RelationDeviceDialog.vue?vue&type=script&lang=js&"
import style0 from "./RelationDeviceDialog.vue?vue&type=style&index=0&id=1b3820bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3820bc",
  null
  
)

export default component.exports